@if (!isResetCodes && PermissionsEnum.ShowMSP360ControlMobileApplication | can: 'read') {
  <div class="fw-semibold">
    {{ 'shared:tfa.recoveryCode.accountIsSecured' | i18next }}
  </div>
}

<div [ngClass]="{ 'mt-2': !isResetCodes }">{{ 'shared:tfa.recoveryCode.recoveryCodes' | i18next }}</div>
<div class="text-xs mt-1">{{ 'shared:tfa.recoveryCode.emergencyCases' | i18next }}</div>

<div class="mt-3">{{ codesGeneratedDate }}</div>

<ul
  class="list-unstyled fw-semibold mt-1"
  id="codes">
  <li *ngFor="let code of codes">{{ code }}</li>
</ul>

<div>
  <mbs-button
    class="mr-2"
    type="secondary"
    icon="fa fa-download"
    (click)="save()"
    >{{ 'shared:tfa.recoveryCode.saveToFile' | i18next }}
  </mbs-button>
  <mbs-button
    class="mr-2"
    type="secondary"
    icon="fa fa-clipboard"
    (click)="copy()"
    >{{ 'shared:tfa.recoveryCode.clipboard' | i18next }}
  </mbs-button>
  <mbs-button
    type="secondary"
    icon="fa fa-print"
    (click)="print()"
    >{{ 'shared:tfa.recoveryCode.print' | i18next }}
  </mbs-button>
</div>
